import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

const BackofficeTicketsPage = lazy(() => import('../../../../main/backoffice/tickets/BackofficeTicketsPage'));

const TicketDetails = lazy(() => import('../../../../main/common/tickets/ticket-details/TicketDetails'));
const NewTicket = lazy(() => import('../../../../main/backoffice/tickets/components/new-ticket/NewTicket'));
const TicketDescription = lazy(
  () => import('../../../../main/common/tickets/ticket-details/components/ticket-description/TicketDescription'),
);
const TicketComments = lazy(
  () => import('../../../../main/common/tickets/ticket-details/components/ticket-comments/TicketComments'),
);
const TicketLogs = lazy(
  () => import('../../../../main/common/tickets/ticket-details/components/ticket-logs/TicketLogs'),
);

export const backOfficeTicketsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense fallback={<DataLoader />}>
        <BackofficeTicketsPage />
      </Suspense>
    ),
  },
  {
    path: 'add-new',
    element: (
      <Suspense fallback={<DataLoader />}>
        <NewTicket />
      </Suspense>
    ),
  },
  {
    path: ':ticketId',
    element: (
      <Suspense fallback={<DataLoader />}>
        <TicketDetails viewType="admin" />
      </Suspense>
    ),
    children: [
      {
        path: '',
        element: <Navigate replace to="details" />,
      },
      {
        path: 'details',
        element: (
          <Suspense fallback={<DataLoader />}>
            <TicketDescription />
          </Suspense>
        ),
      },
      {
        path: 'comments',
        element: (
          <Suspense fallback={<DataLoader />}>
            <TicketComments />
          </Suspense>
        ),
      },
      {
        path: 'logs',
        element: (
          <Suspense fallback={<DataLoader />}>
            <TicketLogs />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Error404Page />,
  },
  {
    path: ':any/*',
    element: <Error404Page />,
  },
];
